import React from "react";
import Banner from "./Banner";
import "./Contact.css";
const Contact = () => {
  return (
    <div>
      <div>
        <Banner title="contact" imgURL="/images/contactbanner.jpg" />
      </div>
      <div className="contact-us">
        <h2>Contact Us</h2>
        <div className="contact-details">
          <div className="contact-section">
            <h3>Corporate Office</h3>
            <p>
              <strong>Nikunj Udyog</strong>
            </p>
            <p>Railway Station Road, Opp Sector 4, Gurgaon (Haryana)</p>
            <p>Ph: +91-124-2325916, +91-124-2250106</p>
            <p>
              E-mail:{" "}
              <a href="mailto:gurgaon@dagagroup.co.in">
                gurgaon@dagagroup.co.in
              </a>
            </p>
          </div>

          <div className="contact-section">
            <h3>Branch Office</h3>
            <p>
              <strong>Gayatri Udyog</strong>
            </p>
            <p>
              Octroi Post Road, Sect 58, Opp. Plot No. 719, Faridabad (Haryana)
            </p>
            <p>
              E-mail:{" "}
              <a href="mailto:faridabad@dagagroup.co.in">
                faridabad@dagagroup.co.in
              </a>
            </p>
          </div>

          {/* <div className="contact-section">
            <h3>Branch Office</h3>
            <p>
              <strong>Anupam Steel Centre</strong>
            </p>
            <p>Y-168, Loha Mandi, Naraina, New Delhi</p>
            <p>Ph: +91-11-25706060</p>
            <p>
              E-mail:{" "}
              <a href="mailto:info@dagagroup.co.in">info@dagagroup.co.in</a>
            </p>
          </div> */}

          {/* <div className="contact-section">
            <h3>Branch Office</h3>
            <p>
              <strong>M/s Prompt</strong>
            </p>
            <p>Z-205, Loha Mandi, Naraina, New Delhi</p>
            <p>Ph: +91-93504-17403</p>
            <p>
              E-mail:{" "}
              <a href="mailto:naraina@dagagroup.co.in">
                naraina@dagagroup.co.in
              </a>
            </p>
          </div> */}

          <div className="contact-section">
            <h3>Branch Office</h3>
            <p>
              <strong>Gappu Ispat</strong>
            </p>
            <p>7, Loha Mandi, Ghaziabad (UP)</p>
            <p>Ph: +91-93102-55647</p>
            <p>
              E-mail:{" "}
              <a href="mailto:info@dagagroup.co.in">info@dagagroup.co.in</a>
            </p>
          </div>

          {/* <div className="contact-section">
            <h3>Corporate Office</h3>
            <p>DD-22, Kalkaji Extn, New Delhi</p>
            <p>Ph: +91-11-47776777 (100 nos), 47776767</p>
            <p>
              E-mail:{" "}
              <a href="mailto:info@dagagroup.co.in">info@dagagroup.co.in</a>
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Contact;
